import { render, staticRenderFns } from "./PasswordResetSent.vue?vue&type=template&id=796ecaaa&scoped=true"
import script from "./PasswordResetSent.vue?vue&type=script&lang=js"
export * from "./PasswordResetSent.vue?vue&type=script&lang=js"
import style0 from "./PasswordResetSent.vue?vue&type=style&index=0&id=796ecaaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796ecaaa",
  null
  
)

export default component.exports